import { render, staticRenderFns } from "./EditarDerivacionLaboratorio.vue?vue&type=template&id=6e56c971"
import script from "./EditarDerivacionLaboratorio.vue?vue&type=script&lang=js"
export * from "./EditarDerivacionLaboratorio.vue?vue&type=script&lang=js"
import style0 from "./EditarDerivacionLaboratorio.vue?vue&type=style&index=0&id=6e56c971&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports